import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
// Fix for default marker icons in React Leaflet
const icon = 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png';
const iconShadow = 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png';
const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34]
});
L.Marker.prototype.options.icon = DefaultIcon;
const locations = [
// Illinois
{
  name: 'Elgin',
  state: 'IL',
  lat: 42.0354,
  lng: -88.2826
}, {
  name: 'Barrington',
  state: 'IL',
  lat: 42.1542,
  lng: -88.1365
}, {
  name: 'Crystal Lake',
  state: 'IL',
  lat: 42.2411,
  lng: -88.3162
}, {
  name: 'McHenry',
  state: 'IL',
  lat: 42.3334,
  lng: -88.2668
}, {
  name: 'Libertyville',
  state: 'IL',
  lat: 42.2831,
  lng: -87.9531
}, {
  name: 'Gurnee',
  state: 'IL',
  lat: 42.3703,
  lng: -87.902
}, {
  name: 'Lake Forest',
  state: 'IL',
  lat: 42.2586,
  lng: -87.8407
}, {
  name: 'Highland Park',
  state: 'IL',
  lat: 42.1817,
  lng: -87.8003
},
// Wisconsin
{
  name: 'Lake Geneva',
  state: 'WI',
  lat: 42.5917,
  lng: -88.4334
}, {
  name: 'Fontana',
  state: 'WI',
  lat: 42.5478,
  lng: -88.5762
}, {
  name: 'Williams Bay',
  state: 'WI',
  lat: 42.5781,
  lng: -88.5401
}];
export function ServiceAreaMap() {
  const center: [number, number] = [42.35, -88.2];
  const radiusCenter: [number, number] = [42.3, -88.2];
  return <div className="w-full h-[300px] md:h-[400px] rounded-2xl overflow-hidden shadow-xl border border-white/20 relative z-10" data-id="element-166">
      <MapContainer center={center} zoom={9} scrollWheelZoom={false} className="w-full h-full" data-id="element-167">
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" data-id="element-168" />

        {/* 90-minute travel radius indicator */}
        <Circle center={radiusCenter} radius={45000} // ~45km radius to visually represent the service area
      pathOptions={{
        color: '#22c55e',
        fillColor: '#22c55e',
        fillOpacity: 0.1,
        weight: 2
      }} data-id="element-169" />

        {/* City Markers */}
        {locations.map((loc, idx) => <Marker key={idx} position={[loc.lat, loc.lng]} data-id="element-170">
            <Popup data-id="element-171">
              <div className="font-medium text-gray-900" data-id="element-172">
                {loc.name}, {loc.state}
              </div>
            </Popup>
          </Marker>)}
      </MapContainer>
    </div>;
}